module.exports = __webpack_public_path__ + "img/top1.627b224d.jpg";